import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  data: {},
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    initUser: (state, action) => {
      const { token, user } = action.payload;
      state.token = token;
      state.data = user ?? {};
    },
    deleteToken: (state) => {
      state.token = null;
    },
  },
});

export const { setToken, initUser, deleteToken } = userSlice.actions;

export const selectToken = (state) => state.user.token;
export const selectUserData = (state) => state.user.data;

export default userSlice.reducer;
